import React from 'react';
import { Collection } from '@/components/AdForm/AdForm.types';
import { Checkbox } from '@/components/UI/Checkbox/Checkbox';
import { PropertyOption } from '@/api/types/categories.types';
import {
  CheckboxAppearance,
  CheckboxSize,
} from '@/components/UI/Checkbox/Checkbox.types';

type Props = {
  option: PropertyOption;
  collection?: Collection;
  onOptionClick: (option: PropertyOption) => void;
  appearance?: CheckboxAppearance;
  highlightLabel?: boolean;
  size?: CheckboxSize;
};

export const CollectionFormSelectOption = ({
  option,
  collection,
  onOptionClick,
  appearance,
  highlightLabel,
  size = 'sm',
}: Props) => {
  const isChecked =
    option.legacyResourceId.toString() ===
    (collection?.[option.propertyLegacyId] as PropertyOption)?.legacyResourceId;

  return (
    <Checkbox
      onChangeHook={() => onOptionClick(option)}
      key={option.name}
      value={isChecked}
      label={option.name}
      appearance={appearance || 'radioCheckIcon'}
      size={size}
      highlightLabel={highlightLabel}
      dataTestId={`property-option-${option.legacyResourceId}`}
    />
  );
};
